import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
import classnames from 'classnames';
import Colors from "../../Color/Colors";
import { Text } from "../../Text/Text/Text";
import styles from "./PrimaryCard.module.scss";
import { Image } from "../../Image/Image/Image";
import { IconButton } from "../../Button/IconButton/IconButton";
import { Breakpoint } from "../../Responsive/Breakpoint/Breakpoint";
import { Link } from "../../Button/Link/Link";
import Utility from "../../Utility/Utility";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PrimaryCard = function PrimaryCard(_ref) {
  var _badge$image, _badge$image$desktop, _badge$image2, _badge$image2$mobile, _image$desktop, _image$mobile, _badge$image3, _badge$image3$mobile, _badge$image4, _badge$image4$desktop, _image$mobile2, _image$desktop2;
  var idx = _ref.idx,
    badge = _ref.badge,
    heading = _ref.heading,
    accessibilityLabel = _ref.accessibilityLabel,
    image = _ref.image,
    link = _ref.link,
    backgroundColor = _ref.backgroundColor,
    options = _ref.options,
    version = _ref.version;
  var renderIconButtonCTA = function renderIconButtonCTA(size) {
    return /*#__PURE__*/_jsx("div", {
      className: classnames(styles.buttonContainer, {
        [styles.buttonContainerV2]: version === 'v2'
      }),
      children: /*#__PURE__*/_jsx(IconButton, {
        iconClassName: styles.iconButton,
        icon: options !== null && options !== void 0 && options.warm ? 'primary-link-circle-2' : 'primary-link-circle',
        size: size,
        fill: options !== null && options !== void 0 && options.warm ? undefined : Colors.colorWW110,
        onClick: function onClick() {},
        attributes: {
          tabIndex: -1,
          'aria-hidden': 'true'
        }
      })
    });
  };
  var HeadingComponent = function HeadingComponent() {
    return /*#__PURE__*/_jsx(Text, {
      richText: true,
      typog: heading.typog,
      textElement: "span",
      className: styles.heading,
      "aria-hidden": "true",
      children: heading.text
    });
  };
  var hasHeading = !!(heading && heading.text);
  var hasBadge = !!(badge && badge !== null && badge !== void 0 && (_badge$image = badge.image) !== null && _badge$image !== void 0 && (_badge$image$desktop = _badge$image.desktop) !== null && _badge$image$desktop !== void 0 && _badge$image$desktop.src && badge !== null && badge !== void 0 && (_badge$image2 = badge.image) !== null && _badge$image2 !== void 0 && (_badge$image2$mobile = _badge$image2.mobile) !== null && _badge$image2$mobile !== void 0 && _badge$image2$mobile.src);
  var hasImage = !!(image && image !== null && image !== void 0 && (_image$desktop = image.desktop) !== null && _image$desktop !== void 0 && _image$desktop.src && image !== null && image !== void 0 && (_image$mobile = image.mobile) !== null && _image$mobile !== void 0 && _image$mobile.src);
  var isWarm = options === null || options === void 0 ? void 0 : options.warm;
  var style = backgroundColor ? {
    backgroundColor: backgroundColor
  } : undefined;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(options !== null && options !== void 0 && options.mobileFullWidth ? styles.mobileFullWidth : styles.mobileSideBySide, (options === null || options === void 0 ? void 0 : options.extendedMobileLayout) && styles.extendedMobileLayout, {
      [styles.primaryCardContainer]: !isWarm,
      [styles.primaryCardWarmContainer]: isWarm,
      [styles.largeDesktop]: options === null || options === void 0 ? void 0 : options.largeDesktop,
      [styles.mobileFixedHeight]: options === null || options === void 0 ? void 0 : options.mobileFixedHeight,
      [styles.compactHeadline]: options === null || options === void 0 ? void 0 : options.compactHeadline,
      [styles.primaryCardV1]: version === 'v1',
      [styles.primaryCardV2]: version === 'v2',
      [styles.primaryCardV3]: !isWarm && version === 'v3',
      [styles.primaryCardOne]: idx === 1,
      [styles.primaryCardTwo]: idx === 2,
      [styles.primaryCardThree]: idx === 3,
      [styles.primaryCardFour]: idx === 4
    }),
    style: style,
    children: [/*#__PURE__*/_jsx(Link, {
      href: link === null || link === void 0 ? void 0 : link.url,
      attributes: link === null || link === void 0 ? void 0 : link.attributes,
      className: styles.link,
      accessibilityLabel: accessibilityLabel || Utility.toPlainText((heading === null || heading === void 0 ? void 0 : heading.text) || '')
    }), hasHeading && hasBadge && /*#__PURE__*/_jsxs("div", {
      className: styles.headingWithBadge,
      children: [/*#__PURE__*/_jsxs(Breakpoint, {
        breakpoint: 'small',
        children: [(badge === null || badge === void 0 ? void 0 : (_badge$image3 = badge.image) === null || _badge$image3 === void 0 ? void 0 : (_badge$image3$mobile = _badge$image3.mobile) === null || _badge$image3$mobile === void 0 ? void 0 : _badge$image3$mobile.src) && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({
          className: styles.badgeImage
        }, badge.image.mobile), {}, {
          loading: "eager",
          "aria-hidden": "true"
        })), (badge === null || badge === void 0 ? void 0 : (_badge$image4 = badge.image) === null || _badge$image4 === void 0 ? void 0 : (_badge$image4$desktop = _badge$image4.desktop) === null || _badge$image4$desktop === void 0 ? void 0 : _badge$image4$desktop.src) && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({
          className: styles.badgeImage
        }, badge.image.desktop), {}, {
          loading: "eager",
          "aria-hidden": "true"
        }))]
      }), /*#__PURE__*/_jsx(HeadingComponent, {})]
    }), hasHeading && !hasBadge && /*#__PURE__*/_jsx(HeadingComponent, {}), version === 'v3' && !isWarm && renderIconButtonCTA('24px'), version === 'v3' && isWarm && /*#__PURE__*/_jsxs(Breakpoint, {
      breakpoint: 'large',
      children: [renderIconButtonCTA('28px'), renderIconButtonCTA('32px')]
    }), version !== 'v3' && /*#__PURE__*/_jsxs(Breakpoint, {
      breakpoint: 'small',
      children: [renderIconButtonCTA('24px'), renderIconButtonCTA('48px')]
    }), hasImage && /*#__PURE__*/_jsxs("div", {
      className: classnames(styles.imageContainer, {
        [styles.imageContainerV2]: version === 'v2'
      }),
      children: [version !== 'v3' && /*#__PURE__*/_jsx("div", {
        className: styles.circle
      }), /*#__PURE__*/_jsxs(Breakpoint, {
        breakpoint: 'small',
        children: [((_image$mobile2 = image.mobile) === null || _image$mobile2 === void 0 ? void 0 : _image$mobile2.src) && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({
          className: styles.image
        }, image.mobile), {}, {
          "aria-hidden": "true"
        })), ((_image$desktop2 = image.desktop) === null || _image$desktop2 === void 0 ? void 0 : _image$desktop2.src) && /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({
          className: styles.image
        }, image.desktop), {}, {
          "aria-hidden": "true"
        }))]
      })]
    })]
  });
};